import createClient from "openapi-fetch";
import { VOISLOG_API_URL } from "../../environments";
import type { paths } from "../../types/voislog_api";
import {
  wafMiddleware,
  authMiddleware,
  variantTunnelMiddleware,
} from "./index";

// スキーマ未公開のAPIエンドポイント定義
type privatePaths = {
  "/v2/core/auth/google/token": {
    post: {
      requestBody: { content: { "application/json": { credential: string } } };
      responses: {
        200: { content: { "application/json": { access_token: string } } };
      };
    };
  };
};

export const voislogApi = createClient<paths & privatePaths>({
  baseUrl: VOISLOG_API_URL,
  headers: { "X-App-Id": "vAnalysis", "X-App-Version": __APP_VERSION__ },
});

// openapi-fetchのonResponseは登録順と逆順に実行されるため、
// wafMiddlewareを最優先で実行させるには最後に登録する
voislogApi.use(authMiddleware);
voislogApi.use(variantTunnelMiddleware);
voislogApi.use(wafMiddleware);
